"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPROXIMATE_CHILD_INCOMES = exports.APPROXIMATE_ADULT_INCOMES = exports.PROVINCES = exports.CIVIL_STATUSES = void 0;
var CIVIL_STATUSES;
(function (CIVIL_STATUSES) {
    CIVIL_STATUSES["single"] = "single";
    CIVIL_STATUSES["commonLawPartner"] = "commonLawPartner";
    CIVIL_STATUSES["married"] = "married";
    CIVIL_STATUSES["widowed"] = "widowed";
    CIVIL_STATUSES["separated"] = "separated";
    CIVIL_STATUSES["divorced"] = "divorced";
})(CIVIL_STATUSES = exports.CIVIL_STATUSES || (exports.CIVIL_STATUSES = {}));
var PROVINCES;
(function (PROVINCES) {
    /** Alberta */
    PROVINCES["ab"] = "ab";
    /** British Columbia */
    PROVINCES["bc"] = "bc";
    /** Manitoba */
    PROVINCES["mb"] = "mb";
    /** New Brunswick */
    PROVINCES["nb"] = "nb";
    /** Newfoundland and Labrador */
    PROVINCES["nl"] = "nl";
    /** Nova Scotia */
    PROVINCES["ns"] = "ns";
    /** Northwest Territories */
    PROVINCES["nt"] = "nt";
    /** Nunavut */
    PROVINCES["nu"] = "nu";
    /** Ontario */
    PROVINCES["on"] = "on";
    /** Prince Edward Island */
    PROVINCES["pe"] = "pe";
    /** Quebec */
    PROVINCES["qc"] = "qc";
    /** Saskatchewan */
    PROVINCES["sk"] = "sk";
    /** Yukon */
    PROVINCES["yt"] = "yt";
})(PROVINCES = exports.PROVINCES || (exports.PROVINCES = {}));
var APPROXIMATE_ADULT_INCOMES;
(function (APPROXIMATE_ADULT_INCOMES) {
    APPROXIMATE_ADULT_INCOMES["noIncome"] = "noIncome";
    APPROXIMATE_ADULT_INCOMES["income0to25"] = "income0to25";
    APPROXIMATE_ADULT_INCOMES["income25to50"] = "income25to50";
    APPROXIMATE_ADULT_INCOMES["income50andMore"] = "income50andMore";
})(APPROXIMATE_ADULT_INCOMES = exports.APPROXIMATE_ADULT_INCOMES || (exports.APPROXIMATE_ADULT_INCOMES = {}));
var APPROXIMATE_CHILD_INCOMES;
(function (APPROXIMATE_CHILD_INCOMES) {
    APPROXIMATE_CHILD_INCOMES["noIncome"] = "noIncome";
    APPROXIMATE_CHILD_INCOMES["income0to10"] = "income0to10";
    APPROXIMATE_CHILD_INCOMES["income10andMore"] = "income10andMore";
})(APPROXIMATE_CHILD_INCOMES = exports.APPROXIMATE_CHILD_INCOMES || (exports.APPROXIMATE_CHILD_INCOMES = {}));
//# sourceMappingURL=person.js.map